import { Module } from 'vuex';
import { RootState } from '@/store/types';
// eslint-disable-next-line import/no-cycle
import actions from '@/store/directory/actions';
import mutations from '@/store/directory/mutations';
import { DirectoryState } from './types';

const state: DirectoryState = {
  platforms: [],
  platformsIsLoading: false,
  costCenters: [],
  costCentersIsLoading: false,
  costAccounts: [],
  costAccountsIsLoading: false,
};

const namespaced = true;

const directory: Module<DirectoryState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
};

export default directory;
